import { ApiProperty } from '@nestjs/swagger';
import { RmEvaluationSamplesInfo } from './rm-evaluation-samples.dto';

export class RmEvaluationInfo{

    @ApiProperty()
    rmEvaluationId?: number;
    
    @ApiProperty()
    grnId: number;

    @ApiProperty()
    grnItemId: number;

    @ApiProperty()
    vehicleId: number;

    @ApiProperty()
    productId: number;

    @ApiProperty()
    arrivalTime: Date;

    @ApiProperty()
    startTimeOfObv: Date;

    @ApiProperty()
    freqencyOfInsp: number;

    @ApiProperty()
    batchNumber: string;

    @ApiProperty()
    centerOrSourceCode: string;

    @ApiProperty()
    totalQuantity: number;

    @ApiProperty()
    noOfSamplesDrawn: number;
    
    @ApiProperty()
    remarks: string;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    createdUser: string | null;


    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;


    @ApiProperty()
    versionFlag: number;

    @ApiProperty({type: [RmEvaluationSamplesInfo]})
    RmEvalSamplesInfo: RmEvaluationSamplesInfo[];
}